import { styled } from '@mui/material/styles';

import {
    lightGreyBoxShadow,
    rem,
    remToGapMultiplier,
    Theme,
} from '../../theme';
import { ButtonBase } from '../Button';
import { Heading } from '../Heading';
import { ImageStandalone } from '../ImageStandalone';
import { Paragraph } from '../Paragraph';

export const tileWidthMobile = 31.6; //'31.6rem';
export const tileWidthDesktop = 106.4; //'106.4rem';
export const tileImageWidthDesktop = 35.8; //'35.8rem';

interface StyledWrapperProperties {
    $fullWidth: boolean;
    theme: Theme;
}

export const StyledWrapper = styled('div')<StyledWrapperProperties>`
    ${({ theme, $fullWidth }) => `
        width: ${$fullWidth ? '100%' : theme.tggSpacing(rem(tileWidthMobile), tileWidthMobile * remToGapMultiplier)};
        margin: ${theme.tggSpacing([rem(2.4), 'auto'], [10, 'auto'])};
        overflow: hidden;
        border-radius: ${theme.tggSpacing(rem(1), 2.5)};
        box-shadow: ${lightGreyBoxShadow};

        ${theme.breakpoints.up('desktop')} {
            width: calc(100%);
            max-width: ${$fullWidth ? '100%' : theme.tggSpacing(rem(tileWidthDesktop), tileWidthDesktop * remToGapMultiplier)};
            padding-bottom: ${theme.tggSpacing(rem(2), 5)};
        }
	`}
`;

export const StyledImageStandalone = styled(ImageStandalone)`
    ${({ theme }: { theme: Theme }) => `
        height: ${theme.tggSpacing(rem(15), 37.5)};
        object-fit: cover;

        ${theme.breakpoints.up('desktop')} {
            height: ${theme.tggSpacing(rem(tileImageWidthDesktop), tileImageWidthDesktop * remToGapMultiplier)};
        }
	`}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => theme.typography.h3}
    ${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.primary.main};
        margin-bottom: ${theme.tggSpacing(rem(1.5), 3.75)};
	`}
`;

export const StyledCTASection = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: ${theme.tggSpacing(rem(1.4), 6)};

        ${theme.breakpoints.up('desktop')} {
            flex-direction: row;
        }
	`}
`;

export const StyledButton = styled(ButtonBase)`
    ${({ theme }: { theme: Theme }) => theme.typography.text_18_bold};
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(0.8), 0], [3, 0])};

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(27.6), 110)};
            margin: ${theme.tggSpacing([rem(1.2), rem(0.5), 0, rem(0.5)], [5, 1.25, 0, 1.25])};
        }
	`}
`;

interface HeadingContentProperties {
    $alignText: 'left' | 'center' | 'right';
    $extraPadding: boolean;
    theme: Theme;
}

export const StyledHeadingContent = styled('div')<HeadingContentProperties>`
    ${({ theme, $alignText, $extraPadding }) => `
        padding: ${$extraPadding ? theme.tggSpacing([rem(2), rem(3), rem(3)], [5, 7.5, 7.5]) : theme.tggSpacing(rem(2), 5)};
        text-align: ${$alignText};

        ${theme.breakpoints.up('desktop')} {
            padding: ${$extraPadding ? theme.tggSpacing([rem(3.5), rem(10.9), rem(6), rem(10.9)], [8.75, 44, 15, 44]) : theme.tggSpacing(rem(2), 5)};
        }
	`}
`;

export const StyledGymLocationHeading = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmallBold};
`;
